const envPublicUrl =
  process.env.PUBLIC_URL && process.env.PUBLIC_URL !== "/"
    ? process.env.PUBLIC_URL
    : "";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  contextPath: envPublicUrl ? envPublicUrl : "/",
  url: (subUrl: string) => `${envPublicUrl}${subUrl}`,
  servers: {
    gateway: {
      enabled: true,
      // url: "https://preprod.test.wrapsodyeco.com/eco-gateway",
      url: "https://plz28.test.wrapsodyeco.com/eco-gateway",
      // url: "https://staging-cloud-f2b7x.wrapsodyeco.com/eco-gateway",
      // url: "https://cloudservice.wrapsodyeco.com/eco-gateway",
      // url: "/eco-gateway",
      // url: "http://127.0.0.1:8081/eco-gateway",
    },
  },
};
